import { useQueryHelper } from '@anytag/shared-hooks';
import { PostDetailsType } from '@anytag/shared-types';
import {
  useInstagramAnalyticsReelDetailsQuery,
  useInfluencerInstagramAnalyticsReelDetailsQuery
} from '@anytag/graphql';
import { PostModal, usePostModalContext } from '../shared';

export type TemplatePostDetailsType = Pick<PostDetailsType, 'id' | 'mainSocialAccountId'>;

export interface TemplateProps {
  className?: string;
  isAnalytics?: boolean;
}

export const Template = ({ className, isAnalytics }: TemplateProps) => {
  const { t, enqueueSnackbar } = useQueryHelper();
  const { closeModal, selectedPost } = usePostModalContext<TemplatePostDetailsType>();
  const { data, loading } = useInfluencerInstagramAnalyticsReelDetailsQuery({
    skip: !selectedPost?.id || !selectedPost?.mainSocialAccountId || isAnalytics,
    variables: { postId: Number(selectedPost?.id), socialAccountId: Number(selectedPost?.mainSocialAccountId) },
    onError: (error) => {
      closeModal?.();
      enqueueSnackbar(t(error.message), { variant: 'error' });
    }
  });
  const { data: analyticsData, loading: fetchingAnalyticsData } = useInstagramAnalyticsReelDetailsQuery({
    skip: !selectedPost?.id || !selectedPost?.mainSocialAccountId || !isAnalytics,
    variables: { postId: Number(selectedPost?.id), accountId: Number(selectedPost?.mainSocialAccountId) },
    onError: (error) => {
      closeModal?.();
      enqueueSnackbar(t(error.message), { variant: 'error' });
    }
  });

  const details = data?.influencerInstagramAnalyticsReelDetails || analyticsData?.instagramAnalyticsReelDetails;

  return (
    <PostModal.DetailsTemplate
      className={className}
      loading={loading || fetchingAnalyticsData}
      data={
        details
          ? {
              isReel: true,
              socialMedia: 'INSTAGRAM',
              postUrl: details?.postUrl,
              caption: details?.content,
              postDate: details?.postDate,
              comments: details.commentList || [],
              images: details?.thumbnail ? [details?.thumbnail] : [],
              statistics: {
                likes: details?.analysis?.likes,
                comments: details?.analysis?.comments,
                views: details?.analysis?.views,
                saves: details?.analysis?.saves,
                reach: details?.analysis?.reach,
                shares: details?.analysis?.shares
              },
              info: {
                avatar: details?.avatarUrl,
                followers: details.followers,
                name: details?.instagramAccountName
              }
            }
          : undefined
      }
    />
  );
};
